
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DotsLoading extends Vue {
  @Prop({ type: Boolean, default: false })
    loading: boolean;
}
